import { shouldPollUpload, useSocialUploadPolling } from '@app/modules/social-export/publish';
import { webApi } from '@mi-front/api-clients';
import { ComposeSocialExportUploadItemCard } from './ComposeSocialExportUploadItemCard';

interface ComposeSocialExportUploadItemProps {
  upload: webApi.CompositionSocialUploadItemDto;
}

/**
 * Single composition social upload row: polls while pending, then renders the card.
 */
export function ComposeSocialExportUploadItem({
  upload: initialUpload,
}: ComposeSocialExportUploadItemProps) {
  const shouldPoll = shouldPollUpload(initialUpload);

  const polledQuery = useSocialUploadPolling(initialUpload.id, {
    enabled: shouldPoll,
  });

  const upload = shouldPoll
    ? ((polledQuery.data ?? initialUpload) as webApi.CompositionSocialUploadItemDto)
    : initialUpload;

  return <ComposeSocialExportUploadItemCard upload={upload} />;
}
